import axios from 'axios'
import config from 'app/config'

const axiosInstance = () => {
    const headers = {}

    const instance = axios.create({
        baseURL: config.API_BASE_URL,
        withCredentials: true,
        headers,
    })

    instance.interceptors.response.use(
        res => res,
        err => {
            return Promise.reject({
                status: err.response?.status,
                message: err.response?.data?.errorMessage || err.response?.statusText,
                name: err.response?.statusText,
            })
        }
    )

    return instance
}

export default axiosInstance
